import { PublicClientApplication } from '@azure/msal-browser';
import { isMicrosoftLoginEnabled, msalConfig } from './msalConfig';

let msalInstance = null;

export const getMsalInstance = () => {
  if (!isMicrosoftLoginEnabled()) {
    return null;
  }

  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
  }

  return msalInstance;
};

export const initializeMsal = async () => {
  const instance = getMsalInstance();
  if (!instance) {
    return null;
  }

  await instance.initialize();
  return instance;
};
